import { styled } from 'styled-components';
import { StyledCard } from './RadioCardRoot';

export const RadioCardIndicator = styled.div`
  --wui-radio-card-indicator-size: 14px;
  --wui-radio-card-indicator-background-color: var(--wui-color-bg-surface);
  --wui-radio-card-indicator-fill-color: var(--wui-color-bg-fill);

  /* TODO: figure out radio / checkbox / switch colors */
  --wui-radio-card-indicator-border-color: var(--wui-color-border-secondary-active);

  width: var(--wui-radio-card-indicator-size);
  height: var(--wui-radio-card-indicator-size);
  min-width: var(--wui-radio-card-indicator-size);
  min-height: var(--wui-radio-card-indicator-size);
  background-color: var(--wui-radio-card-indicator-background-color);
  box-shadow: inset 0 0 0 1px var(--wui-radio-card-indicator-border-color);
  border-radius: 100%;
  position: relative;
  cursor: pointer;
  transition: border-color var(--wui-motion-duration-03) var(--wui-motion-ease);

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background-color: var(--wui-radio-card-indicator-fill-color);
    border-radius: 100%;
    transform: translate(-50%, -50%);
  }

  ${StyledCard}:has(input:checked) & {
    --wui-radio-card-indicator-border-color: var(--wui-color-focus-ring);
    --wui-radio-card-indicator-fill-color: var(--wui-color-focus-ring);

    &::after {
      width: calc(var(--wui-radio-card-indicator-size) / 2);
      height: calc(var(--wui-radio-card-indicator-size) / 2);
    }
  }

  ${StyledCard}:has(input:disabled) & {
    --wui-radio-card-indicator-border-color: var(--wui-color-border-secondary);
    --wui-radio-card-indicator-background-color: var(--wui-color-bg-surface-disabled);
  }
`;

RadioCardIndicator.displayName = 'RadioCardIndicator';
